import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none border-0",
  {
    variants: {
      variant: {
        default: "chip chip-active shadow-[0_4px_10px_-6px_rgba(37,99,235,0.18)]",
        secondary: "chip chip-neutral shadow-none",
        destructive: "chip chip-danger",
        outline: "border border-[var(--athr-border-soft)] bg-[var(--athr-surface)] text-[var(--athr-text-secondary)] shadow-none",
        neutral: "chip chip-neutral",
        info: "chip chip-info",
        success: "chip chip-success",
        warning: "chip chip-warning",
        danger: "chip chip-danger",
        pdf: "chip chip-pdf",
        video: "chip chip-video",
        mood: "bg-[var(--athr-mood-accent)] text-[var(--athr-mood-text)] shadow-[var(--athr-mood-shadow)]",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> { }

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}
